import { createFileRoute } from '@tanstack/react-router'
import { parseSearch } from '@/app/router/search-params'
import { SharedMapRoute } from '@/app/shell/map-route-shell'
import { publicMapExperience } from '@/experiences/public-map'

export const Route = createFileRoute('/')({
  validateSearch: parseSearch,
  component: RouteComponent,
  head: () => ({
    meta: [
      { title: 'FloodNet NYC Map' },
      { name: 'description', content: 'Interactive map of flood events in NYC with real-time sensor data and historical context.' },
      { name: 'keywords', content: 'flood, map, NYC, sensors, real-time, historical, events' },
    ],
  }),
})

function RouteComponent() {
  const search = Route.useSearch()
  return (
    <SharedMapRoute
      routePath={Route.fullPath}
      search={search}
      experience={publicMapExperience}
      timeRangeNavigationEnabled
      hideOfflineSensors={false}
      hideRetiredSensors={false}
    />
  )
}
